import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import App from './App.tsx';
import { msalConfig } from './config/authConfig';
import './index.css';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App msalInstance={msalInstance} />
  </StrictMode>
);